export default __webpack_public_path__ + "static/media/stonewell_logo_blk_white.d4558749.png";